module.exports = __webpack_public_path__ + "img/Auriga.44435b21.png";